export const lazyI18nResources = import.meta.glob('/src/app/i18n/*/*.json', { eager: false });
